export default "__VITE_ASSET__37692645__"